module.exports = __webpack_public_path__ + "img/VERS2.125ea6ec.png";